var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document_icon",
    "data-name": "document icon",
    transform: "translate(-277 -1199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2623",
    "data-name": "Path 2623",
    d: "M0,0H26V26H0Z",
    transform: "translate(277 1199)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1834",
    "data-name": "Group 1834",
    transform: "translate(277 1199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    transform: "translate(1 1)",
    fill: "#fff",
    stroke: "#52555e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1833",
    "data-name": "Group 1833",
    transform: "translate(3.5 2.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2589",
    "data-name": "Path 2589",
    d: "M-12831,11985.719a2.577,2.577,0,0,0-.3,1.281l.031,12.5a1.712,1.712,0,0,0,.516,1.156,1.664,1.664,0,0,0,.938.313l9.683-.151a1.3,1.3,0,0,0,.875-.422,2.9,2.9,0,0,0,.422-1.4l.047-10.917-3.089-2.927-8.156.094A1.4,1.4,0,0,0-12831,11985.719Z",
    transform: "translate(12834.797 -11983)",
    fill: "none",
    stroke: "#52555e",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    d: "M0,0H7.906",
    transform: "translate(5.5 8.5)",
    fill: "none",
    stroke: "#52555e",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2591",
    "data-name": "Path 2591",
    d: "M0,0H6.149",
    transform: "translate(5.5 5.5)",
    fill: "none",
    stroke: "#52555e",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2593",
    "data-name": "Path 2593",
    d: "M0,0H7.906",
    transform: "translate(5.5 10.5)",
    fill: "none",
    stroke: "#52555e",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2594",
    "data-name": "Path 2594",
    d: "M0,0H7.906",
    transform: "translate(5.5 13.5)",
    fill: "none",
    stroke: "#52555e",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2595",
    "data-name": "Path 2595",
    d: "M0,0H7.906",
    transform: "translate(5.5 15.5)",
    fill: "none",
    stroke: "#52555e",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2590",
    "data-name": "Path 2590",
    d: "M-12821.812,11985.5l.219,2.777h2.594Z",
    transform: "translate(12835 -11983)",
    fill: "none",
    stroke: "#52555e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document_icon.55bbf2df334aff4bbe6717ae46b286a7.svg";
export { ForwardRef as ReactComponent };